export default __webpack_public_path__ + "b14984ac648520dadbb3c66da73a136b.svg";